export default __webpack_public_path__ + "static/media/Hoops Complete Import Template.81b5e8b8.csv";